import { Button, InputGroup, Intent, NumericInput, SelectMenu, ListMenu, ColorPicker, CustomLabel, } from "@focus/focusUI";
import { LineStyle } from "../interfaces/element";
import { ObjectType } from "../interfaces/object";
import produce from "immer";
import * as React from "react";
import { deleteObject } from "../models/object";
import { createObject } from "../models/object";
export const GrafosObjectsDialog = (props) => {
    const { content, onUpdate, objects } = props;
    const [selected, setSelected] = React.useState(-1);
    const selectedObject = selected >= 0 && objects[selected];
    const updateColor = (color) => {
        const updatedContent = produce(objects, (draft) => {
            const currentObject = draft[selected];
            currentObject.color = color.hex;
        });
        onUpdate(updatedContent);
    };
    const parseCoords = (value) => {
        const newValue = value
            .replace(/\s+/g, " ")
            .split(" ")
            .map(function (val) {
            return parseFloat(val);
        });
        return newValue;
    };
    const updateField = (fieldName) => (event) => {
        const value = event.target ? event.target.value : event;
        const updatedContent = produce(objects, (draft) => {
            const currentObject = draft[selected];
            currentObject[fieldName] = value;
            if (fieldName === "coordsString") {
                const newCoords = parseCoords(value);
                currentObject.coords = newCoords;
            }
        });
        onUpdate(updatedContent);
    };
    return (React.createElement("div", { className: "focus-grafosConfig" },
        React.createElement("div", { className: "focus-grafosConfig_leftPanel" },
            React.createElement("div", { className: "focus-objects-add-delete-container", role: "deleteAddContainer" },
                React.createElement(Button, { icon: "plus", role: "addObjectButton", className: "delete-object", onClick: () => onUpdate(createObject(objects, content.id, setSelected)) })),
            React.createElement(CustomLabel, { text: "Objects" },
                React.createElement(ListMenu, { canRemove: true, canSelect: true, selectedItem: objects[selected], items: objects, itemRenderer: (object, _index) => `Object_${objects.indexOf(object)}`, onSelect: (_item, index) => setSelected(index), onRemove: (_item, indexToDelete) => {
                        onUpdate(deleteObject(objects, indexToDelete));
                        const indexShouldBeReduced = selected === objects.length - 1 || selected > indexToDelete;
                        indexShouldBeReduced && setSelected(selected - 1);
                    } }))),
        React.createElement("div", null, selectedObject && (React.createElement(React.Fragment, null,
            React.createElement(CustomLabel, { text: "Title" },
                React.createElement(InputGroup, { intent: Intent.PRIMARY, onChange: updateField("title"), value: selectedObject.title })),
            React.createElement(CustomLabel, { text: "text" },
                React.createElement(InputGroup, { intent: Intent.PRIMARY, onChange: updateField("text"), value: selectedObject.text })),
            React.createElement(CustomLabel, { text: "type" },
                React.createElement(SelectMenu, { options: Object.keys(ObjectType), onChange: updateField("type"), value: selectedObject.type })),
            React.createElement(CustomLabel, { text: "style" },
                React.createElement(SelectMenu, { options: Object.keys(LineStyle), onChange: updateField("lineStyle"), value: selectedObject.lineStyle })),
            React.createElement(CustomLabel, { text: "Line Width" },
                React.createElement(NumericInput, { intent: Intent.PRIMARY, onValueChange: updateField("lineWidth"), value: selectedObject.lineWidth })),
            React.createElement(CustomLabel, { text: "coordsString" },
                React.createElement(InputGroup, { intent: Intent.PRIMARY, onChange: updateField("coordsString"), value: selectedObject.coordsString })),
            React.createElement(CustomLabel, { text: "color" },
                React.createElement(ColorPicker, { onChange: updateColor, color: selectedObject.color })))))));
};
//# sourceMappingURL=GrafosObjectsDialog.js.map